import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Get, useFetch } from '../../hooks/useFetch';
import useToken from '../../features/authentication/hooks/useToken';
import { useTranslation } from 'react-i18next';

// Environment List component

export default function EnvironmentList({ setToken, clearToken }) {
  const { token } = useToken();
  const { data } = useFetch(`/Authentication/token/${token.token}/Environments`);
  const [environmentId, setEnvironmentId] = useState();
  const { t } = useTranslation();

  // Handle Change Function
  const handleChange = (event) => {
    setEnvironmentId(event.target.value);
  };

  useEffect(() => {
    handleSubmit();
  }, []);

  // Handle Submit Form function

  const handleSubmit = async () => {
    // e.preventDefault();

    var errorElement = document.getElementById('loginError');
    errorElement.innerHTML = '';
    const envId = process.env.REACT_APP_ENVIRONMENT_ID;
    // console.log(envId,'env');

    Get(
      `/Authentication/refresh/${token.token}?environmentId=${envId}`,
      (response) => {
        setToken(response);
        location = '/';
      },
      (error, text) => {
        if (error == 401) {
          errorElement.innerHTML = t('invalidTokenPlease');
        } else {
          errorElement.innerHTML = text;
        }
      }
    );
  };

  // Clear Token function

  const handleClear = () => {
    clearToken();
    location = '/';
  };

  return (
    <div className='page-wrapper page-center d-none'>
      <div className='container-tight py-4'>
        <div className='text-center mb-4'></div>
        <form
          className='card card-md box-shadow'
          onSubmit={handleSubmit}
          autoComplete='off'
          noValidate
        >
          <div className='card-body'>
            <div className='text-center  d-print-none text-white'>
              <img
                src={`/images/logo-dark.png`}
                alt='Pillars'
                style={{ maxWidth: '300px', maxHeight: '120px' }}
              />
            </div>
            <h2 className='h2 text-center mb-4'>{t('selectEnvironment')}</h2>
            <p>{t('thereIsMoreThan')}</p>
            <div className='text-danger'></div>
            <div className='mb-3'>
              <div className='form-selectgroup form-selectgroup-boxes d-flex flex-column'>
                {data &&
                  data.map((env) => {
                    return (
                      <label key={env.id} className='form-selectgroup-item flex-fill'>
                        <input
                          type='radio'
                          name='envId'
                          value={env.id}
                          className='form-selectgroup-input'
                          onChange={handleChange}
                        />
                        <div className='form-selectgroup-label d-flex align-items-center p-3'>
                          <div className='me-3'>
                            <span className='form-selectgroup-check'></span>
                          </div>
                          <div>{env.name}</div>
                        </div>
                      </label>
                    );
                  })}
              </div>
              <span id='loginError' className='text-danger'></span>
            </div>
            <div className='form-footer'>
              <button
                className='btn btn-primary w-100'
                tabIndex='4'
                onClick={handleSubmit}
              >
                {t('signIn')}
              </button>
            </div>
          </div>
        </form>
        <div className='text-center text-muted mt-3'>
          <span>
            {t('notFindingWhatYouNeed')}?{' '}
            <a href='#' onClick={handleClear} tabIndex='-1'>
              {t('signOut')}
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}

EnvironmentList.propTypes = {
  setToken: PropTypes.func.isRequired,
  clearToken: PropTypes.func.isRequired,
};
